import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { RootState } from '@/store';
import { formatError, projectClassesApi } from '@/services/api';

export const fetchBundledList = createAsyncThunk(
  'organization-projectClass/fetchBundledList',
  async (_, { getState, rejectWithValue }) => {
    const rootState = getState() as RootState;
    const organizationId = rootState.auth.current.organization.id;
    try {
      const response = await projectClassesApi.getList({
        data: {
          organizationId,
        },
      });
      return response;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response !== undefined) {
        return rejectWithValue({ error: formatError(error.response) });
      }
      throw error;
    }
  },
);
